// ---
import React from "react";
import {connect} from "react-redux";
import {Field, formValueSelector, reduxForm} from "redux-form";
import {ff, form, utils} from "@mc/mc-legacy";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import FileUploadField from "../field/FileUploadField";
import FileUploadApi from "../../api/gen/qsign/FileUploadApi";
import * as findCombinationsActions from "../../actions/findCombinationsActions";
import TypeCombinationField from "../field/TypeCombinationField";

const Form = form.Form;
const FormBody = form.FormBody;
const FormActions = form.FormActions;

const validate = (formData) => {
  const errors = {};

  if (!formData.name) {
    errors.name = "Musí být vyplněn název";
  }

  if (!formData.signPracovnikId) {
    errors.signPracovnikId = "Musí být vyplněn podepisující";
  }
    if(formData.description&& formData.description.length>1000){
        errors.description = "Poznámka může mít maximálně 1000 znaků";
    }
  if (formData.files) {
    if (formData.files.length === 0) {
      errors.files = "Musí být vybrán alespoň jeden PDF nebo PDF/A soubor k podpisu";
    } else {
      let sign = 0;
      formData.files.forEach(f => {
        if (!f.attachment) {
          sign++;
        }
      });
      if (sign === 0) {
        errors.files = "Musí být vybrán alespoň jeden PDF nebo PDF/A soubor k podpisu";
      }
    }
  }

  return errors;
};

/**
 * Formulář nového požadavku k hromadnému podepsání dokumentů.
 */
class NovyVlastniPozadavekForm extends React.Component {

  static formName = "novyVlastniPozadavekForm";

  componentWillUnmount() {
    const { files } = this.props;
    files && files.length > 0 && FileUploadApi.deleteDocuments(files.map((v) => v.uuid));
  }

  render() {
    const { onClose, handleSubmit, submitting, typeCombinationItems } = this.props;
    const commons = {
      disabled: submitting,
    };
    const items = [];
    return (
      <Form onSubmit={handleSubmit} className={"novy-pozadavek-form"}>
        <FormBody cards>
          <Row noGutters>
            <Col xs={6}>
              <Field component={FileUploadField} max={50} onChange={() => {
                  this.props.change('_filesHack', Date.now()); // potřebuju vynutit validaci kvůli změně typu přílohy
              }} multiple={true} name={"files"} {...commons} />
            </Col>
            <Col xs={6}>
              <Card>
                <CardHeader>
                  <h2>Údaje požadavku</h2>
                </CardHeader>
                <CardBody>
                  <ff.String name={"name"} label={"Název"} required {...commons} />
                  <ff.Base
                      componentClass={TypeCombinationField}
                      name={"typeCombinationId"}
                      label={"Kombinace podepsání"}
                      items={typeCombinationItems}
                      required
                      {...commons}
                  />
                  <ff.Textarea rows={10} name={"description"} label={"Poznámka"} {...commons} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </FormBody>
        <FormActions onClose={onClose} disabled={submitting} submitButton={"Odeslat"} cancelButton />
      </Form>
    );
  }
}

function mapStateToProps(state) {
  const selector = formValueSelector(NovyVlastniPozadavekForm.formName);
  return {
    files: selector(state, "files"),
    KombinaceList: utils.storeFromArea(state, findCombinationsActions.KOMBINACE_LIST),
  };
}

const reduxFormObj = reduxForm({
  form: NovyVlastniPozadavekForm.formName,
  validate: validate,
})(NovyVlastniPozadavekForm);
export default connect(mapStateToProps)(reduxFormObj);
